<div class="item-container">
  <div *ngIf="activityType === FieldActivityType.NONE; else showElse">
    <div [ngStyle]="cssImageStyle"></div>
  </div>

  <ng-template #showElse>
    <ng-container *ngIf="isStandardIcon(activityType, displayText)">
      <div class="item-frm" [ngStyle]="styleBlock">
        <div class="icon-blink-wrapper {{styleIcon}}">
          <img [src]="getIconPath(activityType, displayText)" />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activityType === FieldActivityType.MEDICINE || activityType === FieldActivityType.MEDICINENYUSHO">
      <div class="item-frm" [ngStyle]="styleBlock">
        <div class="icon-blink-wrapper {{styleIcon}}">
          <img src="../../../../../assets/icons/thuoc.svg"/>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activityType === FieldActivityType.PLUS">
      <div class="item-frm" [ngStyle]="styleBlock">
        <div class="icon-blink-wrapper {{styleIcon}}">
          <img src="../../../../../assets/icons/plus-icon.svg" />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activityType === FieldActivityType.CHECK">
      <div class="item-frm" [ngStyle]="styleBlock">
        <div class="icon-blink-wrapper {{styleIcon}}">
          <img src="../../../../../assets/icons/check-icon.svg" />
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activityType === FieldActivityType.NO_EXCRETION">
      <div class="item-frm" [ngStyle]="styleBlock">
        <div class="icon-blink-wrapper {{styleIcon}}">
          <img src="../../../../../assets/icons/diamond-icon.svg" />
        </div>
      </div>
    </ng-container>
  </ng-template>
</div>
